import { render } from "./LoadingInsideAContainer.vue?vue&type=template&id=06be5218"
import script from "./LoadingInsideAContainer.vue?vue&type=script&lang=ts"
export * from "./LoadingInsideAContainer.vue?vue&type=script&lang=ts"

import "./LoadingInsideAContainer.vue?vue&type=style&index=0&id=06be5218&lang=css"
script.render = render

export default script